import { NavLink } from 'react-router-dom';
import styles from './TripNav.module.css';

interface NavItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}

const ITEMS: NavItem[] = [
  { to: '/', label: 'Plan', icon: '📋', end: true },
  { to: '/now', label: 'Now', icon: '🔴' },
  { to: '/chat', label: 'Chat', icon: '💬' },
  { to: '/crew', label: 'Crew', icon: '👥' },
  { to: '/games', label: 'Games', icon: '🎮' },
  { to: '/map', label: 'Karte', icon: '🗺️' },
  { to: '/recap', label: 'Recap', icon: '📖' },
];

/**
 * Sticky Bottom-Nav für die fünf Hauptsektionen eines Trips.
 * Per `NavLink` mit `end`-Flag für die Plan-Route, damit sie nicht auch dann
 * highlighted bleibt wenn man bereits auf /chat ist.
 *
 * Anmerkung: /now, /chat, /crew und /map zeigen aktuell denselben PlanPage —
 * die echten Pages kommen in den Folge-Slices, die Nav-Struktur ist aber
 * bewusst schon da, damit das UI nicht in Slice-Häppchen umgebaut werden muss.
 */
export function TripNav() {
  return (
    <nav className={styles.nav} aria-label="Trip-Navigation">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `${styles.item} ${isActive ? styles.active : ''}`}
        >
          <span className={styles.icon} aria-hidden="true">{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
